<template>
  <div class="comBox">
    <div class="box-header" :class="{borderB: bder}">
      <div><slot name="name"></slot></div>
      <div><slot name="other"></slot></div>
    </div>
    <div class="box-content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'comBox',
  props: ['bder']
}
</script>

<style scoped>
.comBox{
    width:100%;
    padding:0.15rem 0.24rem;
    position:relative;
}
.box-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
}
.borderB{
   border-bottom:1px solid rgba(97,97,97,0.05);
}
.box-content{
  height:100%;
}
</style>
